<template>
	<div class="menus-wrap" style="border: 1px solid #eee;">
		<template v-if="id">
			<success-view></success-view>
		</template>
		<template v-else>
			<promise-view
				v-show="active === 1"
				@update:active="
					val => {
						active = val;
					}
				"
			></promise-view>
			<form-view
				v-show="active === 2"
				@update:active="
					val => {
						active = val;
					}
				"
			></form-view>
		</template>
	</div>
</template>

<script>
import FormView from './components/Form';
import PromiseView from './components/Promise';
import SuccessView from './components/Success';
import { mapState } from 'vuex';
export default {
	components: {
		FormView,
		PromiseView,
		SuccessView
	},
	data() {
		return {
			active: 1
		};
	},
	computed: {
		...mapState({
			id: state => state.user.examinee.id,
			examination_id: state => state.system.examInfo.examination_id
		})
	}
};
</script>
